import { defaultParseSearch } from '@tanstack/react-router'

/** q ist Freitext, auch bei direkt geöffneten Links mit Zahlen/JSON.
 * Quoted Strings aus bestehenden Router-Links bleiben normal dekodiert;
 * andere Parameter und mehrdeutige mehrfache q behalten den Routervertrag. */
export function parseAppSearch(search: string): Record<string, unknown> {
  const parsed: Record<string, unknown> = defaultParseSearch(search)
  const queries = new URLSearchParams(search).getAll('q')
  if (queries.length === 1 && typeof parsed.q !== 'string') {
    parsed.q = queries[0]
  }
  return parsed
}

/** Eine nichtleere Vertrags-ID hält den Sheet-Kontext in der URL. Ungültige
 * Werte werden beim Routenvalidieren entfernt, statt ein leeres Modal zu
 * öffnen. */
export function contractSearch(value: unknown): { contract?: string | undefined } {
  return { contract: typeof value === 'string' && value !== '' ? value : undefined }
}

export const CONTRACT_FACETS = ['dokumente', 'aufgaben', 'termine', 'stammdaten'] as const
export type ContractFacet = (typeof CONTRACT_FACETS)[number]

export function contractFacetSearch(value: unknown): { contractFacet?: ContractFacet | undefined } {
  return {
    contractFacet: CONTRACT_FACETS.includes(value as ContractFacet) ? (value as ContractFacet) : undefined,
  }
}

/** `/energie?haus=<id>&zaehler=<id>` (Spec 46a, „Web · URL"): Haus-Filter und
 * geöffnetes Zählerdetail. Nichtleere Strings bleiben, alles andere fällt auf
 * „Alle"/kein Detail zurück — beide Schlüssel stehen immer im Ergebnis, auch
 * als `undefined`, damit der Router einen rohen Wert sicher überschreibt (Fund
 * zu `von` in `router.tsx::GeldSearchParams`). */
export interface EnergieSearch {
  haus: string | undefined
  zaehler: string | undefined
}

function nonEmptyString(value: unknown): string | undefined {
  return typeof value === 'string' && value !== '' ? value : undefined
}

export function energieSearch(search: Record<string, unknown>): EnergieSearch {
  return { haus: nonEmptyString(search.haus), zaehler: nonEmptyString(search.zaehler) }
}
